import { styled } from "styled-components";

export const Section = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
